<template>
	<div class="edit_wrap">
		<!-- tab -->
		<div class="add_top">
			<div class="add_tab active_tab" @click="choiceTab">申请大V店已有品牌</div>
			<div class="add_tab" @click="addTab">添加新品牌</div>
		</div>
		<p align="center" class="main_word mt20" v-if="status==9">复审驳回后部分信息不能修改</p>
		<!-- 申请大V店已有品牌 -->
		<div v-show="isChoice">
			<!-- 搜索 -->
			<div class="add_search mt20 clearfix" v-if="status!=9">
				<el-button class="r ml10 mr20" type="primary" @click="keySearch">搜索</el-button>
				<el-input class="w325 r" v-model="brand_key" placeholder="输入品牌名称关键字，搜索大V店是否已有该品牌" @keyup.native.enter="keySearch"></el-input>
			</div>

			<!-- 中英文名称 -->
			<div class="add_name mt20">
				<div class="c_name">
					<span class="main_word mr4">*</span>
					<span class="form_color">品牌中文名称：</span>
					<span v-if="!alSelect" class="main_word f12">根据您选择搜索到的大V店已有品牌，系统自动填充中文名称</span>
                    <span v-else>{{ brandName }}</span>
				</div>
				<div class="e_name mt20">
					<span class="main_word mr4">*</span>
					<span class="form_color">品牌英文名称：</span>
					<span v-if="!alSelect" class="main_word f12">根据您选择搜索到的大V店已有品牌，系统自动填充英文名称</span>
                    <span v-else>{{ brandEnname }}</span>
				</div>
			</div>
		</div>
		<!-- 添加新品牌 -->
		<div class="add_brand mt20" v-show="!isChoice">
			<el-form :model="addForm" :rules="rules" ref="addForm" label-width="200px" class="demo-ruleForm">
                <span class="ml90 f999">如果【申请大V店已有品牌】功能没有找到您要经营的品牌，请添加品牌信息，审核通过后会将品牌信息录入大V店品牌库：</span>
				<!-- 品牌中文名称 -->
				<el-form-item class="mt10" label="品牌中文名称：" prop="brandName">
					<el-input :disabled="status==9" class="w250" v-model="addForm.brandName" placeholder="请输入品牌中文名称"></el-input>
				</el-form-item>
				<!-- 品牌英文名称 -->
				<el-form-item label="品牌英文名称：" prop="brandEnname">
					<el-input :disabled="status==9" class="w250" v-model="addForm.brandEnname" placeholder="请输入品牌英文名称"></el-input>
				</el-form-item>
                <span class="ml200 f999">如果品牌没有中文名称或者英文名称，请在“中文名称”和“英文名称”输入相同的内容。</span>
				<!-- 品牌介绍 -->
				<el-form-item label="品牌介绍：" prop="brandDesc" class="dib mt20">
					<el-input :disabled="status==9" class="w500" :autosize="{ minRows: 6, maxRows: 10}" type="textarea" v-model="addForm.brandDesc" placeholder="入驻品牌的介绍，品牌商品的卖点" :maxlength="200"></el-input>
				</el-form-item>
				<span class="word_num">您可以输入 <span class="main_word">{{ amount }}</span> 个字</span>
				<!-- 重点商品 -->
				<el-form-item label="重点商品：" prop="brandGoodsDesc">
					<el-input :disabled="status==9" class="w500" :autosize="{ minRows: 6, maxRows: 10}" type="textarea" v-model="addForm.brandGoodsDesc" placeholder="重点商品介绍及线上链接，建议三款商品左右"></el-input>
				</el-form-item>
			</el-form>
		</div>
		<!-- 信息验证 -->
		<div class="mt20">
			<el-form :model="brandInfo" :rules="rules" ref="brandInfo" label-width="207px" class="demo-ruleForm">

				<!--品牌合作品类-->
				<!--{{cata.first}}-->
				<el-form-item label="品牌合作品类：" class="dib" v-show="status!=9">
					<span class="main_word rule_star120 vtb">*</span>
					<el-select class="ml_10 vtb" v-model="cata.first" placeholder="请选择一级类目"
							   @change="getTowList">
						<el-option v-for="val in oneList" :label="val.name" :value="val.id"
								   :key="val.id"></el-option>
						<!-- <el-option label="区域二" value="beijing"></el-option> -->
					</el-select>
				</el-form-item>
				<!-- {{cata.second}} -->
				<el-form-item class="dib sign" v-show="status!=9">
					<el-select class="vtb" v-model="cata.second" placeholder="请选择二级类目"
							   @change="getThreeList">
						<el-option v-for="val in twoList" :label="val.name" :value="val.id"
								   :key="val.id"></el-option>
						<!-- <el-option label="区域二" value="beijing"></el-option> -->
					</el-select>
				</el-form-item>
				<!-- {{cata.categoryId}} -->
				<el-form-item class="dib sign" v-show="status!=9">
					<el-select class="vtb" @change="selectInfo" v-model="cata.categoryId"
							   placeholder="请选择三级类目">
						<el-option v-for="val in threeList" :label="val.name" :value="val.id"
								   :key="val.id"></el-option>
						<!-- <el-option label="区域二" value="beijing"></el-option> -->
					</el-select>
				</el-form-item>
				<el-button v-show="status!=9" class="vtb" type="primary" @click="addDomain">添加合作类目</el-button>

				<!--表格-->
				<el-table :data="supplierApplyCategories" border style="width: 80%;margin: 0 auto;margin-bottom:22px"
				>
					<el-table-column
							label="主营品类"
							min-width="200"
							align="center">
						<template scope="scope">
							<span>{{ scope.row.category.grandName }}--</span>
							<span>{{ scope.row.category.parentName }}--</span>
							<span>{{ scope.row.category.childrenName }}</span>
						</template>
					</el-table-column>

					<el-table-column label="操作" min-width="100" align="center">
						<template scope="scope">
							<el-button v-if="status!=9"
									size="small"
									type="danger"
									@click="deleteDomain(scope.$index, scope.row)">删除
							</el-button>
							<el-button v-if="status==9" type="text">不可操作</el-button>
						</template>
					</el-table-column>
				</el-table>


				<!-- 商品是否进口 -->
				<el-form-item label="商品是否进口：">
					<span class="main_word rule_star118">*</span>
					<el-radio-group class="f666 f12 ml_10" v-model="brandInfo.goodsType" @change="goodsTypeChange">
						<el-radio :disabled="registeredCountry !=1" :label="1"><span class="f14 f666">非进口</span></el-radio>
						<el-radio :label="2"><span class="f14 f666">进口</span></el-radio>
					</el-radio-group>
				</el-form-item>
				<!-- 品牌经营方式 -->
				<el-form-item label="品牌经营方式：" prop="businessType">
					<span class="main_word rule_star118 vtb">*</span>
					<el-select class="ml_10 vtb" v-model="brandInfo.businessType" placeholder="请选择品牌经营方式" @change="businessTypeChange">
						<el-option value="1" label="自有品牌"></el-option>
						<el-option value="2" label="代理商"></el-option>
						<el-option v-show="(registeredCountry == 1 && brandInfo.goodsType == 2) || (registeredCountry != 1)" value="3" label="其他"></el-option>
						<!-- -->
					</el-select>
				</el-form-item>
				<!-- 商标注册证电子版 -->
				<!-- 非图书 商品进口+品牌经营方式（非进口+自由品牌/代理商）/ -->
				<el-form-item v-if="((registeredCountry == 1 && (brandInfo.goodsType == 1) && (brandInfo.businessType == 1 || brandInfo.businessType == 2))
						|| (registeredCountry == 1 && (brandInfo.goodsType == 2) && (brandInfo.businessType == 1 || brandInfo.businessType == 2))
						|| (registeredCountry != 1 && (brandInfo.goodsType == 2) && (brandInfo.businessType == 1 || brandInfo.businessType == 2)) )"
							  label="商标注册证电子版：" class="dib">
					<span class="main_word rule_star145">*</span>
					<span class="f666 f12 ml_10">复印件需加盖公司红章扫描上传</span>
					<el-upload action="/suppliers/uploadImages?biz=0" name="pic" :file-list="brandInfo.trademarkRegistrationCertificateFiles"
							   list-type="picture-card" :on-preview="handlePictureCardPreview" :on-remove="handleRemoveTrademark"
							   :on-success="handleSuccess1" :before-upload="beforeUpload">
						<i class="el-icon-plus"></i>
					</el-upload>

					<span class="f999 f12">上传电子版资质仅支持JPG、GIF、PNG等格式的图片，大小不超过1M，可上传多张</span>
				</el-form-item>
				<!-- 完整授权链证书电子版 -->
				<el-form-item v-if="((registeredCountry == 1 && (brandInfo.goodsType == 1) && (brandInfo.businessType == 1 || brandInfo.businessType == 2))
						|| (registeredCountry == 1 && (brandInfo.goodsType == 2) && (brandInfo.businessType == 1 || brandInfo.businessType == 2))
						|| (registeredCountry != 1 && (brandInfo.goodsType == 2) && (brandInfo.businessType == 1 || brandInfo.businessType == 2)) )"
							  label="上传完整授权链证书电子版：" class="dib mt20">
					<span class="main_word rule_star200">*</span>
					<span class="f666 f12 ml_10">复印件需加盖公司红章扫描上传</span>
					<el-upload action="/suppliers/uploadImages?biz=0" name="pic" :file-list="brandInfo.authCertificateFiles"
							   list-type="picture-card" :on-preview="handlePictureCardPreview" :on-remove="handleRemoveAuthCert"
							   :on-success="handleSuccess2" :before-upload="beforeUpload">
						<i class="el-icon-plus"></i>
					</el-upload>

					<span class="f999 f12">上传电子版资质仅支持JPG、GIF、PNG等格式的图片，大小不超过1M，可上传多张</span>
				</el-form-item>
				<!-- 订货单电子版 -->
				<el-form-item v-if="((registeredCountry == 1 && (brandInfo.goodsType == 2) && (brandInfo.businessType == 3))
						|| (registeredCountry != 1 && (brandInfo.goodsType == 2) && (brandInfo.businessType == 3)) )"
							  label="订货单电子版：" class="dib mt20">
					<span class="main_word rule_star118">*</span>
					<span class="f666 f12 ml_10">复印件需加盖公司红章扫描上传</span>
					<el-upload action="/suppliers/uploadImages?biz=0" name="pic" :file-list="brandInfo.purchaseOrderFiles"
							   list-type="picture-card" :on-preview="handlePictureCardPreview" :on-remove="handleRemovePurchaseOrder"
							   :on-success="handleSuccess3" :before-upload="beforeUpload">
						<i class="el-icon-plus"></i>
					</el-upload>

					<span class="f999 f12">上传电子版资质仅支持JPG、GIF、PNG等格式的图片，大小不超过1M，可上传多张</span>
				</el-form-item>
				<!-- 报关单扫描件 -->
				<el-form-item v-if="((registeredCountry == 1 && (brandInfo.goodsType == 2) && (brandInfo.businessType == 1 || brandInfo.businessType == 2))
						|| (registeredCountry == 1 && (brandInfo.goodsType == 2) && (brandInfo.businessType == 3))
						|| (registeredCountry != 1 && (brandInfo.goodsType == 2) && (brandInfo.businessType == 1 || brandInfo.businessType == 2))
						|| (registeredCountry != 1 && (brandInfo.goodsType == 2) && (brandInfo.businessType == 3)))"
							  label="报关单扫描件：" class="dib mt20">
					<span v-if="!((registeredCountry != 1 && brandInfo.businessType == 3) || (registeredCountry == 1 && brandInfo.goodsType == 2 && brandInfo.businessType == 3))" class="main_word rule_star118">*</span>
					<span class="f666 f12 ml_10">同一批次商品的报关单和出入境检验检疫的证件，复印件需加盖公司红章扫描上传</span>
					<el-upload action="/suppliers/uploadImages?biz=0" name="pic" :file-list="brandInfo.customsDeclarationFormFiles"
							   list-type="picture-card" :on-preview="handlePictureCardPreview" :on-remove="handleRemoveCustomsForm"
							   :on-success="handleSuccess4" :before-upload="beforeUpload">
						<i class="el-icon-plus"></i>
					</el-upload>

					<span class="f999 f12">上传电子版资质仅支持JPG、GIF、PNG等格式的图片，大小不超过1M，可上传多张</span>
				</el-form-item>
				<!-- 入境货物检验检疫证明 -->
				<el-form-item v-if="((registeredCountry == 1 && (brandInfo.goodsType == 2) && (brandInfo.businessType == 1 || brandInfo.businessType == 2))
						|| (registeredCountry == 1 && (brandInfo.goodsType == 2) && (brandInfo.businessType == 3))
						|| (registeredCountry != 1 && (brandInfo.goodsType == 2) && (brandInfo.businessType == 1 || brandInfo.businessType == 2))
						 || (registeredCountry != 1 && (brandInfo.goodsType == 2) && (brandInfo.businessType == 3)))"
							  label="入境货物检验检疫证明：" class="dib mt20">
					<span v-if="!((registeredCountry != 1 && brandInfo.businessType == 3) || (registeredCountry == 1 && brandInfo.goodsType == 2 && brandInfo.businessType == 3))" class="main_word rule_star174">*</span>
					<span class="f666 f12 ml_10">同一批次商品的报关单和出入境检验检疫的证件，复印件需加盖公司红章扫描上传</span>
					<el-upload action="/suppliers/uploadImages?biz=0" name="pic" :file-list="brandInfo.inspectionQuarantineFiles"
							   list-type="picture-card" :on-preview="handlePictureCardPreview" :on-remove="handleRemoveInspectionQuarantine"
							   :on-success="handleSuccess6" :before-upload="beforeUpload">
						<i class="el-icon-plus"></i>
					</el-upload>
					<span class="f999 f12">上传电子版资质仅支持JPG、GIF、PNG等格式的图片，大小不超过1M，可上传多张</span>
				</el-form-item>
				<!-- 质检单电子版 -->
				<el-form-item v-if="(registeredCountry == 1 && ((brandInfo.goodsType == 1) && (brandInfo.businessType == 1 || brandInfo.businessType == 2)))"
							  label="质检单电子版：" class="dib mt20">
					<span class="main_word rule_star118">*</span>
					<span class="f666 f12 ml_10">复印件需加盖公司红章扫描上传</span>
					<el-upload action="/suppliers/uploadImages?biz=0" name="pic" :file-list="brandInfo.qualityInspectionFiles"
							   list-type="picture-card" :on-preview="handlePictureCardPreview" :on-remove="handleRemoveQualityInspection"
							   :on-success="handleSuccess5" :before-upload="beforeUpload">
						<i class="el-icon-plus"></i>
					</el-upload>

					<span class="f999 f12">上传电子版资质仅支持JPG、GIF、PNG等格式的图片，大小不超过1M，可上传多张</span>
				</el-form-item>
				<!--&lt;!&ndash; 质检日期 &ndash;&gt;{{brandInfo.dateTime}}-->
				<el-form-item v-if="(registeredCountry==1 && (brandInfo.goodsType == 1 && (brandInfo.businessType == 1 || brandInfo.businessType == 2)))"
							  label="质检日期：">
					<span class="main_word rule_star90 vtb">*</span>
					<el-date-picker class="ml_10 vtb" v-model="brandInfo.dateTime" type="date"
									placeholder="请选择质检日期" @change="tansform">
					</el-date-picker>
				</el-form-item>

			</el-form>
		</div>
		<!-- 申请大V店已有品牌保存 -->
		<div v-show="isChoice" class="w150 auto mtb20">
			<el-button class="mr10" type="primary" @click="cancel">取消</el-button>
			<el-button type="primary" @click="submitForm('brandInfo')">保存</el-button>
		</div>
		<!-- 添加品牌保存 -->
		<div v-show="!isChoice" class="w150 auto mtb20">
			<el-button class="mr10" type="primary" @click="cancel">取消</el-button>
			<el-button type="primary" @click="save_add('brandInfo')">保存</el-button>
		</div>

		<!--<el-form-item>-->
			<!--<el-button class="mr10" type="primary" @click="cancel">取消</el-button>-->

			<!--<el-button type="primary" @click="save_add('brandInfo')">保存</el-button>-->
		<!--</el-form-item>-->
		<!-- 搜索结果弹框 -->
		<el-dialog title="" :visible.sync="search_result" size="small">
			<div class="wp100 tc">搜索结果如下，若没有您要的品牌，请【添加新品牌】</div>

			<div class="mt20 result_radio">
				<el-radio-group class="radio_group" v-model="radio" @change="change_select">
					<el-radio v-for="val in list" class="list_radio" :label="val.brandId" :key="val.brandId">{{ val.brandName }}</el-radio>
				</el-radio-group>
			</div>

			<span slot="footer" class="dialog-footer">
			    <el-button @click="search_result = false">取 消</el-button>
			    <el-button :disabled="noSelect" type="primary" @click="sure_select">确 定</el-button>
			  </span>
		</el-dialog>
		<!--搜索无内容弹框-->
		<el-dialog title="" :visible.sync="noDialog" size="tiny">
			<span>没有搜索到相关品牌，请[添加新品牌]</span>
			<span slot="footer" class="dialog-footer">
			<el-button type="primary" @click="noDialog = false">确 定</el-button>
		  </span>
		</el-dialog>
		<!--预览图片-->
		<el-dialog :visible.sync="dialogVisible" size="small">
			<img width="100%" :src="dialogImageUrl" alt="">
		</el-dialog>
	</div>
</template>

<script type="text/javascript">
	export default {
		data () {
			return {
				status: 999,			// status=9时 复审驳回
                supplierApplyId: 0, // 申请id
				brandApplyId: 0,    // 品牌申请id
                brandId: 0, 	    // 品牌id
                oneList: [],        // 一级类目列表
                twoList: [],        // 二级类目列表
                threeList: [],      // 三级类目列表
                // 品类列表
                cata: {
                    first: null,
                    second: null,
                    categoryId: null
                },
                // 品类表格
                supplierApplyCategories: [],

                // 品类tpm
                tpmList: {},

                registeredCountry: 0,    // 注册地 1 国内 其他数字： 国外

				// 图片预览
				dialogImageUrl: '',			
        		dialogVisible: false,

				isChoice: true,				// tab 当前页面
				search_result: false,		// 搜索结果弹框
				brand_key: '',			// 品牌关键字搜索
				radio: null,							// 选中的内容
				noDialog: false,			// 无结果
				noSelect: true,			// 未选择品牌
				brandName: '',	// 中文名称
				brandEnname: '',	// 外文名称
				alSelect: false,	// 已选择 品牌

				// 必选项样式
                customsFormRequired: true,				// 报关单
                inspectionQuarantineRequired : true,    // 出入境货物检验检疫证明

				// 非图书 申请品牌信息
				brandInfo: {
					goodsType: 2,		// 商品是否进口
					businessType: '', 	// 经营方式
					trademarkRegistrationCertificateFiles: [],		// 商标注册证电子版
					authCertificateFiles: [],							// 完整授权链证书电子版
					purchaseOrderFiles: [],		// 订货单电子版
					customsDeclarationFormFiles: [],		// 报关单扫描件
					qualityInspectionFiles: [],		// 质检单电子版
					inspectionQuarantineFiles: [],		// 入境货物检验检疫证明
					qualityInspectionDate: null,			// 质检日期
					dateTime: null						// 组件 日期
				},

				// 添加品牌数据
				addForm: {
					brandName: '',
					brandEnname: '',
					brandDesc: '',
					brandGoodsDesc: '',
				},
				list: [],

				// 验证
				rules: {
					brandName: [
						{ required: true, message: '请输入品牌中文名称', trigger: 'blur' }
					],
					brandEnname: [
						{ required: true, message: '请输入品牌英文名称', trigger: 'blur' }
					],
					brandDesc: [
						{ required: true, message: '请输入品牌介绍', trigger: 'blur' },
            { max: 200, message: '最多输入200个字', trigger: 'blur' }
					],
					brandGoodsDesc: [
						{ required: true, message: '请输入请输入重点商品链接', trigger: 'blur' }
					],

					// 非图书 申请验证
					//businessType: [
					//	{ required: true, message: '请选择品牌经营方式', trigger: 'change' }
					//],
					// 商标注册证电子版
					trademarkRegistrationCertificateFile: [
						{ required: true, message: '请上传商标注册证电子版', trigger: 'change' }
					],
					// 组件 日期 未验证
					dateTime: [
						{ required: true, type: 'number', message: '请选择质检日期', trigger: 'change' }
					]
				}
			}
		},
		mounted () {
		    this.supplierApplyId = this.$route.query.supplierApplyId;
            // this.id = this.$route.query.id;
            this.brandApplyId = this.$route.query.id;
            this.registeredCountry = this.$route.query.registeredCountry;
			this.$nextTick(function(){
				$('.el-dialog__footer').css('text-align','center');
                $('.sign .el-form-item__content').css({"marginLeft": "0px"});
                this.getCategory();
				this.fetch();
            })
		},
		methods: {
            fetch () {
                var _this = this;
                var brandApplyId = _this.brandApplyId;
                var supplierApplyId = _this.supplierApplyId;
                if (brandApplyId == 0) {

					// 默认不处理
                } else {
                    $.ajax({
                        url: '/suppliers/supplierSettled/findSupplierApplyBrand',
                        method: 'get',
                        data: {
                            brandApplyId: brandApplyId,
                            supplierApplyId: supplierApplyId
                        },
                        success: function (result) {
                            if (!result.code) {

								_this.status = result.data.status;

                            	// 添加新品牌(注意处理编辑)
                                if (result.data.brandId == 0) {
                                	_this.initEditTab();
                                	_this.brandId = result.data.brandId;
                                    _this.addForm.brandName = result.data.brandName;
                                    _this.addForm.brandEnname = result.data.brandEnname;
                                    _this.addForm.brandDesc = result.data.brandDesc;
                                    _this.addForm.brandGoodsDesc = result.data.brandGoodsDesc;
                                } else {
                                	// 申请品牌(注意处理编辑)
                                    _this.alSelect = true;
                                    _this.brandId = result.data.brandId;
                                    _this.brandName = result.data.brandName;
                                    _this.brandEnname = result.data.brandEnname;

                                }
								_this.supplierApplyCategories = result.data.supplierApplyBrandCategories;
                                _this.registeredCountry = result.data.registeredCountry;
								_this.brandInfo.goodsType = result.data.goodsType;
								if (result.data.businessType) {
                                    // _this.brandInfo.businessType = result.data.businessType;
                                    _this.brandInfo.businessType = result.data.businessType + '';
								} else {
                                    _this.brandInfo.businessType = '';
                                }
								_this.brandInfo.trademarkRegistrationCertificateFiles = _this.fileTrans(result.data.trademarkRegistrationCertificateFile);
								_this.brandInfo.authCertificateFiles = _this.fileTrans(result.data.authCertificateFile);
								_this.brandInfo.purchaseOrderFiles = _this.fileTrans(result.data.purchaseOrderFile);
								_this.brandInfo.customsDeclarationFormFiles = _this.fileTrans(result.data.customsDeclarationFormFile);
								_this.brandInfo.qualityInspectionFiles = _this.fileTrans(result.data.qualityInspectionFile);
								_this.brandInfo.inspectionQuarantineFiles = _this.fileTrans(result.data.inspectionQuarantineFile);

								// 质检日期
								if (result.data.qualityInspectionDate){
                                    _this.brandInfo.dateTime = new Date(result.data.qualityInspectionDate);
								} else {
									_this.brandInfo.dateTime = null;
								}

                            } else {
                                _this.$message({
                                    message: result.msg,
                                    type: 'error'
                                });
                            }
                        }
                    })
                }
            },
            // 转化图片 格式[{url}]
            fileTrans(fileUrl){
                var array = [];
                if(fileUrl) {
                    var files = fileUrl.split(',');
                    for(var i=0;i<files.length;i++) {
                        var file = {};
                        file.url = files[i];
                        console.log(file);
                        array.push(file);
                    }
                }
                return array;
            },
            fileTransToArray(files){
                var fileArray = [];
                if(files) {
                    for(var i=0;i<files.length;i++) {
                        if(files[i].url){
                            fileArray.push(files[i].url);
                        }
                    }
                }
                return fileArray;
            },
            // 图片转化成字符串
            fileTransToString(files){
                var fileStr = "";
                if(files) {
                    for(var i=0;i<files.length;i++) {
                        if(files[i].url){
                            if(i!=0) {
                                fileStr += ",";
                            }
                            fileStr += files[i].url;
                        }
                    }
                }
                return fileStr;
            },

			// 时间转化成时间戳
			tansform (val) {
				this.brandInfo.qualityInspectionDate = new Date(val).getTime();
				console.log(this.brandInfo.qualityInspectionDate)
			},

            // 时间转化成时间戳
            tansformTime (val) {
                this.brandInfo.qualityInspectionDate = new Date(val).getTime();
                console.log(this.brandInfo.qualityInspectionDate)
            },

			// 时间戳 转化成 时间字符
			getTimeStr (val) {
				var date = new Date(val);
				var Y = date.getFullYear() + '-';
				var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
				var D = date.getDate() + ' ';
				return Y+M+D;
			},

			// 切换tab页
			choiceTab () {
                if (this.brandApplyId > 0) {
                    return;
				}
				this.isChoice = true;
				$('.add_tab:eq(0)').addClass('active_tab').siblings().removeClass('active_tab');
			},
			addTab () {
                if (this.brandApplyId > 0) {
                    return;
                }
				this.isChoice = false;
				$('.add_tab:eq(1)').addClass('active_tab').siblings().removeClass('active_tab');
			},

            initEditTab () {
                this.isChoice = false;
                $('.add_tab:eq(1)').addClass('active_tab').siblings().removeClass('active_tab');
            },
			// 搜索
			keySearch () {
				var _this = this;
				var brandName = this.brand_key;
                if (brandName) {
                    $.get({
                        url: '/suppliers/supplierSettled/findBrandByKeyword',
                        data: {
                            brandName: brandName
                        },
                        success: function (result) {
                            if (!result.code) {
                                _this.list = result.data.list;

                                if(_this.list.length == 0) {
                                    _this.noDialog = true;
                                } else {
                                    _this.search_result = true;
                                    _this.radio = null;
                                    _this.noSelect = true;
                                }
                            } else {
                                _this.$message({
                                    showClose: true,
                                    message: result.msg,
                                    type: 'error'
                                });
                            }
                        }
                    })
                } else {
                    this.$message({
                        showClose: true,
                        message: '请输入搜索内容',
                        type: 'error'
                    });
                }

			},
			change_select (val) {
                if (val) {
                    this.noSelect = false;
                }
			},

			// 商品是否进口 change事件
			goodsTypeChange (val) {
                var that = this;
                if (that.registeredCountry == 1 && that.brandInfo.businessType == 3) {
                    that.brandInfo.businessType = '';
				}
			},
			// 经营方式
			businessTypeChange (val) {
				console.log(val)
			},

			// 选中已选品牌
			sure_select () {
                var id = this.radio;
                for (var i=0 ;i <this.list.length;i++)
                {
                    if (id == this.list[i].brandId) {
                        this.brandId = this.list[i].brandId;
                        this.brandName = this.list[i].brandName;
                        this.brandEnname = this.list[i].brandEnname;
                        this.alSelect = true;
                    }
                }
                this.search_result = false;
			},
			// 保存申请已选品牌
			submitForm(formName) {
			    var _this = this;
                var registeredCountry = this.registeredCountry;
                var goodsType = this.brandInfo.goodsType;
                var businessType = this.brandInfo.businessType;
                var registeredCountry = this.registeredCountry;
                if (!this.brandName) {
                    this.$message.error('品牌中文名称不能为空');
                } else if (this.supplierApplyCategories && this.supplierApplyCategories.length == 0) {
                    this.$message.error('请添加合作品类');
                } else {
                    this.$refs[formName].validate((valid) => {
                        if (valid) {
                            var data = {};
                            data = JSON.parse(JSON.stringify(this.brandInfo));
                            if (registeredCountry==1 && goodsType==1 && (businessType==1 || businessType==2 || businessType=='1' || businessType=='2')) {
                                if (this.brandInfo.dateTime == null) {
                                    this.$message.error('请选择质检日期');
                                    return;
                                }
                                var dateTime = _this.brandInfo.dateTime;
                                // 质检日期 时间处理
                                data.qualityInspectionDate = dateTime.getTime();
                            }
                            data.registeredCountry = registeredCountry;
                            data.trademarkRegistrationCertificateFiles = this.fileTransToArray(this.brandInfo.trademarkRegistrationCertificateFiles);
                            data.authCertificateFiles = this.fileTransToArray(this.brandInfo.authCertificateFiles);
                            data.purchaseOrderFiles = this.fileTransToArray(this.brandInfo.purchaseOrderFiles);
                            data.customsDeclarationFormFiles = this.fileTransToArray(this.brandInfo.customsDeclarationFormFiles);
                            data.qualityInspectionFiles = this.fileTransToArray(this.brandInfo.qualityInspectionFiles);
                            data.inspectionQuarantineFiles = this.fileTransToArray(this.brandInfo.inspectionQuarantineFiles);

                            data.supplierApplyBrandCategories = this.supplierApplyCategories;
                            data.registeredCountry = this.registeredCountry;
                            data.brandApplyId = this.brandApplyId;
                            data.supplierApplyId = this.supplierApplyId;
                            data.categoryIsBook = 0;
                            data.brandId = this.brandId;
                            data.brandName = this.brandName;
                            data.brandEnname = this.brandEnname;
                            // 清空冗余数据
                            if (registeredCountry == 1 && goodsType == 2 && (businessType == 1 || businessType == 2)) {//国内+进口+(代理商+自有品牌)
                                data.purchaseOrderFiles = null;
                                data.qualityInspectionFiles = null;
							} else if (registeredCountry == 1 && goodsType == 2 && businessType == 3) {//国内+进口+(其它)
                                data.trademarkRegistrationCertificateFiles = null;
                                data.authCertificateFiles = null;
                                data.qualityInspectionFiles = null;
							} else if (registeredCountry == 1 && goodsType == 1 && (businessType == 1 || businessType == 2)) {//国内+非进口+(代理商+自有品牌)
                                data.purchaseOrderFiles = null;
                                data.customsDeclarationFormFiles = null;
                                data.inspectionQuarantineFiles = null;
                            } else if (registeredCountry != 1 && goodsType == 2 && (businessType == 1 || businessType == 2)) {//国外+进口+(代理商+自有品牌)
                                data.purchaseOrderFiles = null;
                                data.qualityInspectionFiles = null;
                            } else if (registeredCountry != 1 && goodsType == 2 && businessType == 3) {//国外+进口+(其它)
                                data.trademarkRegistrationCertificateFiles = null;
                                data.authCertificateFiles = null;
                                data.qualityInspectionFiles = null;
                            } else {//(国外+非进口) + (国内+非进口+其它) 不存在的情况
                                data.trademarkRegistrationCertificateFiles = null;
                                data.authCertificateFiles = null;
                                data.purchaseOrderFiles = null;
                                data.customsDeclarationFormFiles = null;
                                data.inspectionQuarantineFiles = null;
                                data.qualityInspectionFiles = null;
                            }

                            $.ajax({
                                url: '/suppliers/supplierSettled/saveSupplierApplyBrand',
                                data: JSON.stringify(data),
                                dataType: "json",
                                contentType: 'application/json;charset=utf-8',
                                type: 'POST',
                                success: function (result) {
                                    if (!result.code) {
                                        _this.$message({
                                            message: '保存成功',
                                            type: 'success'
                                        });
                                        setTimeout(function () {
                                            _this.$router.push({
                                                path:'/edit_info_brand?supplierApplyId=' + _this.supplierApplyId
                                            })
                                        },500)
                                    } else {
                                        _this.$message({
                                            message: result.msg,
                                            type: 'error'
                                        });
                                    }
                                }
                            })

                        } else {
                            console.log('error submit!!');
                            return false;
                        }
                    });
                }

            },
			// 保存 添加品牌
			save_add(formName) {
				var _this = this;
				var registeredCountry = this.registeredCountry;
				var goodsType = this.brandInfo.goodsType;
				var businessType = this.brandInfo.businessType;
				if (!this.addForm.brandName) {
					this.$message.error('品牌中文名称不能为空');
				} else if (!this.addForm.brandDesc) {
					this.$message.error('品牌介绍不能为空');
				}else if (!this.addForm.brandGoodsDesc) {
					this.$message.error('重点商品不能为空');
				} else if (this.supplierApplyCategories && this.supplierApplyCategories.length == 0) {
					this.$message.error('请添加合作品类');
				} else {
					this.$refs[formName].validate((valid) => {
						if (valid) {
                            var data = {};

							data = JSON.parse(JSON.stringify(this.brandInfo));
							data.trademarkRegistrationCertificateFiles = this.fileTransToArray(this.brandInfo.trademarkRegistrationCertificateFiles);
							data.authCertificateFiles = this.fileTransToArray(this.brandInfo.authCertificateFiles);
							data.purchaseOrderFiles = this.fileTransToArray(this.brandInfo.purchaseOrderFiles);
							data.customsDeclarationFormFiles = this.fileTransToArray(this.brandInfo.customsDeclarationFormFiles);
							data.qualityInspectionFiles = this.fileTransToArray(this.brandInfo.qualityInspectionFiles);
							data.inspectionQuarantineFiles = this.fileTransToArray(this.brandInfo.inspectionQuarantineFiles);

							data.supplierApplyBrandCategories = this.supplierApplyCategories;

							data.brandApplyId = this.brandApplyId;
							data.supplierApplyId = this.supplierApplyId;
							data.categoryIsBook = 0;
							data.registeredCountry = this.registeredCountry;
							data.brandId = 0;
							data.brandName = this.addForm.brandName;
							data.brandEnname = this.addForm.brandEnname;
							data.brandDesc = this.addForm.brandDesc;
							data.brandGoodsDesc = this.addForm.brandGoodsDesc;

							if (registeredCountry==1 && goodsType==1 && (businessType==1 || businessType==2)) {
								if (this.brandInfo.dateTime == null) {
									this.$message.error('请选择质检日期');
									return;
								}
								var dateTime = _this.brandInfo.dateTime;
								// 质检日期 时间处理
								data.qualityInspectionDate = dateTime.getTime();

							}

							$.ajax({
								url: '/suppliers/supplierSettled/saveSupplierApplyBrand',
								data: JSON.stringify(data),
								dataType: "json",
								contentType: 'application/json;charset=utf-8',
								type: 'POST',
								success: function (result) {
									if (!result.code) {
										_this.$message({
											message: '保存成功',
											type: 'success'
										});
										setTimeout(function () {
											_this.$router.push({
												path:'/edit_info_brand?supplierApplyId=' + _this.supplierApplyId
											})
										},500)
									} else {
										_this.$message({
											message: result.msg,
											type: 'error'
										});
									}
								}
							})

						} else {
							console.log('error submit!!');
							return false;
						}
					});
				}
            },

              // 删除 上传图片
              handleRemove(file, fileList) {
                var _this = this;
                console.log(file, fileList);
                  console.log(_this.brandInfo.authCertificateFiles);
              },

            // 删除 上传图片 商标注册电子版
            handleRemoveTrademark(file, fileList) {
                var _this = this;
                console.log(file, fileList);
                var picFiles = [];
                for (var i = 0; i < fileList.length; i++) {
                    var curPicFile = fileList[i];
                    picFiles.push(curPicFile);
                }
                _this.brandInfo.trademarkRegistrationCertificateFiles = picFiles;
            },

            // 删除 上传图片 完整授权链证书电子版
            handleRemoveAuthCert(file, fileList) {
                var _this = this;
                console.log(file, fileList);
                var picFiles = [];
                for (var i = 0; i < fileList.length; i++) {
                    var curPicFile = fileList[i];
                    picFiles.push(curPicFile);
                }
                _this.brandInfo.authCertificateFiles = picFiles;
            },

            // 删除 上传图片 订货单电子版
            handleRemovePurchaseOrder(file, fileList) {
                var _this = this;
                console.log(file, fileList);
                var picFiles = [];
                for (var i = 0; i < fileList.length; i++) {
                    var curPicFile = fileList[i];
                    picFiles.push(curPicFile);
                }
                _this.brandInfo.purchaseOrderFiles = picFiles;
            },

            // 删除 上传图片 报关单电子版
            handleRemoveCustomsForm(file, fileList) {
                var _this = this;
                console.log(file, fileList);
                var picFiles = [];
                for (var i = 0; i < fileList.length; i++) {
                    var curPicFile = fileList[i];
                    picFiles.push(curPicFile);
                }
                _this.brandInfo.customsDeclarationFormFiles = picFiles;
            },

            // 删除 上传图片 质检单电子版
            handleRemoveQualityInspection(file, fileList) {
                var _this = this;
                console.log(file, fileList);
                var picFiles = [];
                for (var i = 0; i < fileList.length; i++) {
                    var curPicFile = fileList[i];
                    picFiles.push(curPicFile);
                }
                _this.brandInfo.qualityInspectionFiles = picFiles;
            },

            // 删除 上传图片 入境货物检验检测
            handleRemoveInspectionQuarantine(file, fileList) {
                var _this = this;
                console.log(file, fileList);
                var picFiles = [];
                for (var i = 0; i < fileList.length; i++) {
                    var curPicFile = fileList[i];
                    picFiles.push(curPicFile);
                }
                _this.brandInfo.inspectionQuarantineFiles = picFiles;
            },

    		handleRemoveCommon(fileList) {
                var _this = this;
                var picFiles = [];
                for (var i = 0; i < fileList.length; i++) {
                    var curPicFile = fileList[i];
                    picFiles.push(curPicFile);
                }
                return picFiles;
			},

              // 预览 图片
              handlePictureCardPreview(file) {
                this.dialogImageUrl = file.url;
                this.dialogVisible = true;
              },
              // 商标注册证电子版 成功上传
              handleSuccess1(response, file) {
                  if (!response.code) {
//                      this.brandInfo.trademarkRegistrationCertificateFiles.push(response.data);
                      this.brandInfo.trademarkRegistrationCertificateFiles.push({url:response.data});
                  } else {
                      this.$message({
                          showClose: true,
                          message: response.msg,
                          type: 'error'
                      });
                  }
              },
              handleSuccess2(response, file) {
                  if (!response.code) {
//                      this.brandInfo.authCertificateFiles.push(response.data);
                      this.brandInfo.authCertificateFiles.push({url:response.data});

                  } else {
                      this.$message({
                          showClose: true,
                          message: response.msg,
                          type: 'error'
                      });
                  }
              },
              handleSuccess3(response, file) {
                  if (!response.code) {
//                      this.brandInfo.purchaseOrderFiles.push(response.data);
                      this.brandInfo.purchaseOrderFiles.push({url:response.data});

                  } else {
                      this.$message({
                          showClose: true,
                          message: response.msg,
                          type: 'error'
                      });
                  }
              },
              handleSuccess4(response, file) {
                  if (!response.code) {
                      this.brandInfo.customsDeclarationFormFiles.push({url:response.data});
                  } else {
                      this.$message({
                          showClose: true,
                          message: response.msg,
                          type: 'error'
                      });
                  }
              },
              handleSuccess5(response, file) {
                  if (!response.code) {
                      this.brandInfo.qualityInspectionFiles.push({url:response.data});
                  } else {
                      this.$message({
                          showClose: true,
                          message: response.msg,
                          type: 'error'
                      });
                  }
              },
              handleSuccess6(response, file) {
                  if (!response.code) {
                      this.brandInfo.inspectionQuarantineFiles.push({url:response.data});
                  } else {
                      this.$message({
                          showClose: true,
                          message: response.msg,
                          type: 'error'
                      });
                  }
              },
            beforeUpload (file) {
                const isJPG = (file.type === 'image/jpeg') || (file.type === 'image/png') || (file.type === 'image/gif') || (file.type === 'image/jpg');
                const isLt1M = file.size / 1024 / 1024 < 1;
                if (!isJPG) {
                    this.$message.error('上传图片只能是JPG、GIF、PNG等格式的图片格式!');
                    return isJPG;
                }
                if (!isLt1M) {
                    this.$message.error('上传图片大小不能超过 1MB!');
                    return isLt1M;
                }

            },
            // 请求一级类目
            getCategory () {
                var _this = this;
				var supplierApplyId = _this.supplierApplyId;
                $.get({
					url: '/suppliers/supplierSettled/findBrandCategoryApplication',
                    data: {
                        type: '1',
                        categoryId: '',
						supplierApplyId: supplierApplyId
                    },
                    success: function (result) {
                        if (!result.code) {
                            _this.oneList = result.data.list;
                        } else {
                            // _this.$message({
                            //   showClose: true,
                            //   message: result.msg,
                            //   type: 'error'
                            // });
                        }
                    }
                })
            },
            // 请求二级类目
            getTowList (value) {
                this.cata.second = null;
                var _this = this;
				var supplierApplyId = _this.supplierApplyId;
				$.get({
                    url: '/suppliers/supplierSettled/findBrandCategoryApplication',
                    data: {
                        type: '2',
                        categoryId: value,
						supplierApplyId: supplierApplyId
                    },
                    success: function (result) {
                        if (!result.code) {
                            _this.twoList = result.data.list;
                        } else {
                            // _this.$message({
                            //   showClose: true,
                            //   message: result.msg,
                            //   type: 'error'
                            // });
                        }
                    }
                })
            },
            // 请求三级类目
            getThreeList (value) {
                this.cata.categoryId = null;
                var _this = this;
				var supplierApplyId = _this.supplierApplyId;
                $.get({
                    url: '/suppliers/supplierSettled/findBrandCategoryApplication',
                    data: {
                        type: '3',
                        categoryId: value,
						supplierApplyId: supplierApplyId
                    },
                    success: function (result) {
                        if (!result.code) {
                            _this.threeList = result.data.list;
                        } else {
                            // _this.$message({
                            //   showClose: true,
                            //   message: result.msg,
                            //   type: 'error'
                            // });
                        }
                    }
                })
            },
            // 请求三级类目 数据
            selectInfo() {
                var _this = this;
                console.log(_this.cata);
                console.log(_this.cata.categoryId);
                var id = _this.cata.categoryId;
                $.get({

                    url: '/suppliers/supplierSettled/findGoodsCategoryAttribute',
                    data: {
                        categoryId: id
                    },
                    success: function (result) {
                        if (!result.code) {
                            _this.tpmList = result.data;
                        } else {
                            // _this.$message({
                            //   showClose: true,
                            //   message: result.msg,
                            //   type: 'error'
                            // });
                        }
                    }
                })
            },

            // 添加合作类目
            addDomain() {
                var _this = this;
                if ($.isEmptyObject(this.tpmList)) {
                    this.$message.error('请选择主营品类类目');
                } else {
                    var flag = true;
                    var supplierApplyCategories = this.supplierApplyCategories;
                    var level = this.tpmList.category;
                    for (var i = 0; i < supplierApplyCategories.length; i++) {
                        var supplierApplyCategory = supplierApplyCategories[i];
                        var hisLevel = supplierApplyCategory.category;
                        if (flag && hisLevel.childrenId == level.childrenId) {
                            flag = false;
						}
					}
					if (flag) {
                        this.supplierApplyCategories.push(this.tpmList)
                        // 添加成功之后
                        this.cata.first = null;
                        this.tpmList = {};
					} else {
                        this.$message({
                            showClose: true,
                            message: '主营品类已经添加',
                            type: 'error'
                        });
					}
                }
            },
            // 删除合作类目
            deleteDomain(index, row) {
                this.supplierApplyCategories.map((item, num) => {
                    console.log(item);

                    if (index == num) {
                        this.supplierApplyCategories.splice(item, 1);
                    }
                    return item;
                })
                console.log(this.supplierApplyCategories);
            },
            // 取消申请品牌
            cancel () {
                var _this = this;
                this.$confirm('取消后系统将不保存您输入的品牌信息。', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$router.push({
                        path:'/edit_info_brand?supplierApplyId=' + _this.supplierApplyId
                    })
                }).catch(() => {
                    console.log("取消")
                });
            }

		},
		computed: {
			amount: function () {
				return 200 - this.addForm.brandDesc.length;
			}
		}/*,
		watch: {
			'brandInfo.goodsType': function (val) {
				var businessType = this.brandInfo.businessType;
				var registeredCountry = this.registeredCountry;
				if (!(val==2 && val==3)) {
					this.brandInfo.purchaseOrderFiles = [];
				}
				if (val != 2) {
					this.brandInfo.customsDeclarationFormFiles = [];
					this.brandInfo.inspectionQuarantineFiles = [];
				}
				if (!(registeredCountry==1 && val==1 && (businessType==2 || businessType==3))) {
					this.brandInfo.qualityInspectionFiles = [];
					this.brandInfo.qualityInspectionDate = null;
				}
			},
			'brandInfo.businessType': function (val) {
				var goodsType = this.brandInfo.goodsType;
				var registeredCountry = this.registeredCountry;
				if (!(val==1 || val==2)) {
					this.brandInfo.trademarkRegistrationCertificateFiles = [];
					this.brandInfo.authCertificateFiles = [];
				}
				if (!(goodsType==2 && val==3)) {
					this.brandInfo.purchaseOrderFiles = [];
				}
				if (!(registeredCountry==1 && goodsType==1 && (val==2 || val==3))) {
					this.brandInfo.qualityInspectionFiles = [];
					this.brandInfo.qualityInspectionDate = null;
				}
			}
		}*/
	}

</script>

<style type="text/css" lang="less" scoped>
	.edit_wrap {
		width: 1050px;
	  // height: 4000px;
	  margin: 50px auto;
	  border: 1px solid #eee;
	  .add_top {
	  	width: 100%;
	  	height: 40px;
	  	background-color: #f9f9f9;
	  }
	  .add_tab {
	  	display: inline-block;
	  	width: 170px;
	  	height: 40px;
	  	text-align: center;
	  	line-height: 40px;
	  	color: #666;
	  	font-size: 14px;
	  	cursor: pointer;
	  }
	  .active_tab {
	  	border-bottom: 1px solid #ff4a7d;
	  	color: #ff4a7d;
	  }
	  .add_name {
	  	padding-left: 84px;
	  }
	}
	.w500 {
		width: 500px;
	}
	.w250 {
		width: 250px;
	}
	.w165 {
		width: 165px;
	}
	.radio_group {
		width: 90%;
		padding-left: 15%;
		max-height: 150px;
		overflow-y: scroll;
	}
	.list_radio {
		margin-top: 10px;
		margin-left: 10%;
		width: 40%;
		overflow: hidden; 
		text-overflow:ellipsis; 
		white-space: nowrap;
	}
	.mtb20 {
		margin-top: 20px;
        margin-bottom: 20px;
	}
    .w150 {
        width: 150px;
    }
	.w325 {
		width: 325px;
	}
	.result_radio .el-radio + .el-radio {
     margin-left: 10%; 
	}
	.dialog-footer {
		text-align: center;
	}
	.form_color {
		color: rgb(106, 72, 77);
	}
	.rule_star200 {
		position: relative;
		left:-200px;
	}
	.rule_star119 {
		position: relative;
		left:-10px;
	}
	.rule_star145 {
		position: relative;
		left:-145px;
	}
	.rule_star174 {
		position: relative;
		left:-174px;
	}
	.rule_star118 {
		position: relative;
		left:-118px;
	}
	.rule_star124 {
		position: relative;
		left:-124px;
	}
	.rule_star90 {
		position: relative;
		left:-90px;
	}
	.ml_10 {
		margin-left: -10px;
	}
    .ml90 {
        margin-left: 90px;
    }
    .ml200 {
        margin-left:200px;
    }
</style>


// WEBPACK FOOTER //
// notBookAddBrand.vue?bfa8f416